<template>
  <base-dropdown class="mr-2 d-block nav-item dropdown" position="right" menu-classes="menu-width" ref="dropdownref">
    <div class="media" slot="title">
      <base-button type="secondary" style="position: relative;">
        <font-awesome-icon size="2x" icon="bell" class="mr-0"></font-awesome-icon>
        <badge :class="'badge-md badge-circle badge-floating border-white ml-1 ' + badgeStyle">{{count}}</badge>
      </base-button>
    </div>
    <a v-if="count > 0" href="#" @click.prevent="readAllAndRefresh()" class="text-center dropdown-item"><small><strong>alle als gelesen markieren</strong></small></a><li v-else class="text-center dropdown-item"><small><strong>keine neuen Nachrichten</strong></small></li>
    <a v-for="notification in notifications.slice(0, showCount)" href="#" @click.prevent="() => {goToLink(notification.link);patchData(notification).then(() => {refreshData()});}" :key="notification.id" class="dropdown-item dropdown-item-space">
      <badge :type="notification.type.toLowerCase()">{{translations[notification.type]}}</badge>
      <small><strong> [{{ (notification.sender === null || typeof notification.sender === 'undefined') ? "SYSTEM" : notification.sender.firstname + ' ' + notification.sender.lastname }}]
        <i>({{ notification.createdAt|formatDate }})</i></strong></small>
      <br><small>{{notification.message}}</small></a>
    <a v-if="count > showCount" href="#" @click.prevent="showMore()" class="text-center dropdown-item"><small><strong>mehr anzeigen</strong></small></a>
    <a v-if="showCount > defaultShowCount" href="#" @click.prevent="showLess()" class="text-center dropdown-item"><small><strong>weniger anzeigen</strong></small></a>
  </base-dropdown>
</template>
<script>
  import Push from 'push.js';

  export default {
    name:'NotificationBell',
    data() {
      return {
        isLoadingNotifications: false,
        refreshTimer: null,
        defaultShowCount: 3,
        showCount: 3,
        showRead: false,
        notifications: [{
          id: 0,
          type: 'INFO',
          message: 'Willkommen auf Socialguard.app - Der Sozialkonzept Management Software in Spielhallen und Wettbüros',
          createdAt: '',
          readAt: '',
          sender: null
        }],
        translations: {
          DANGER: 'KRITISCH',
          WARNING: 'WARNUNG',
          INFO: 'INFO'
        }
      }
    },
    created() {
      this.showCount = this.defaultShowCount;
      this.refreshData();
      this.refreshTimer = setInterval(() =>{
        this.refreshData()
      }, 60000);
    },
    computed: {
      count () {
        return this.notifications.length
      },
      badgeStyle() {
        return (this.notifications.length > 0) ? 'badge-danger-bright' : 'badge-default-bright'
      }
    },
    watch: {
      count (val, oldVal) {
        if(val > oldVal) {
          this.showNotification('/sounds/normal.mp3');
        }
      }
    },
    methods: {
      refreshData() {
        this.isLoadingNotifications = true;
        this.tick++
        this.getData().then(response => {
          this.notifications = response.member;
          this.isLoadingNotifications = false;
          this.tick++
        }).catch(error => {
          // eslint-disable-next-line no-console
          console.error(error)
          this.isLoadingNotifications = false;
          this.tick++
        })
      },
      toggleParent() {
        this.$refs.dropdownref.toggleDropDown();
      },
      showMore() {
        this.showCount=this.showCount+5;
        this.toggleParent();
      },
      showLess() {
        this.showCount=this.defaultShowCount;
        this.toggleParent();
      },
      switchRead() {
        this.showRead = !this.showread;
        this.refreshData();
        this.toggleParent();
      },
      getData() {
        return new Promise((resolve, reject) => {
          const header = this.authHeader();
          header['Content-Type'] = 'application/json';
          const requestOptions = {
            method: 'GET',
            headers: header,
          };
          fetch(process.env.VUE_APP_API_SERVER + `/api/notifications?pagination=false&order%5Bid%5D=desc&exists%5BreadAt%5D=`+this.showRead+`&receiver=`+this.$store.getters['authentication/uid'], requestOptions)
              .then(this.handleResponse)
              .then(response => {
                    resolve({
                      totalItems: response['hydra:totalItems'],
                      member: response['hydra:member']
                    });

                  },
                  error => {
                    reject(error);
                  });
        });
      },

      readAllAndRefresh() {
        let prs = [];
        this.notifications.forEach(n => {
          prs.push(this.patchData(n));
          });
        Promise.all(prs).then(()=>{
          this.refreshData();
          });
      },
      goToLink(link) {
        if(link.includes('mailto:')) {
          window.location.href = link;
        } else if (link.includes(window.location.origin)) {
          this.$router.push(link.split("#").pop());
        } else {
          window.open(
              link,
              '_blank' // <- This is what makes it open in a new window.
          );
        }
      },
      patchData(notification) {
        return new Promise((resolve, reject) => {

          notification.readAt = new Date();
          let senddata = notification;
          senddata.receiver = senddata.receiver['@id'];

          if(typeof notification.sender !== 'undefined') senddata.sender = senddata.sender['@id'];


          const header = this.authHeader();
          header['Content-Type'] = 'application/merge-patch+json';
          const requestOptions = {
            method: 'PATCH',
            headers: header,
            body: JSON.stringify(senddata)
          };
          fetch(process.env.VUE_APP_API_SERVER + `/api/notifications/`+notification.id, requestOptions)
              .then(this.handleResponse)
              .then(response => {
                    resolve({
                      totalItems: response['hydra:totalItems'],
                      member: response['hydra:member']
                    });

                  },
                  error => {
                    reject(error);
                  });
        });
      },
      playSound (sound) {
        if(sound) {
          let audio = new Audio(sound);
          audio.play();
        }
      },
      showNotification(sound) {
        this.playSound(sound);
        this.pushNotiMsg('Sie haben ungelesene Nachrichten.');
        Push.create("Neue Nachricht", {
          body: "Sie haben ungelesene Nachrichten.",
          icon: '/img/icons/apple-icon.png',
          timeout: 2400000,
          onClick: function () {
            window.focus();
            this.close();
          }
        });
      }
    }
  }
</script>
<style>
  .badge-floating {
    position: absolute !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    border: 3px solid;
  }

  .badge-danger-bright {
    color: white !important;
    background-color: #f80031 !important;
  }

  .badge-default-bright {
    color: #091428 !important;
    background-color: rgba(52, 98, 175, 1) !important;
  }

  .menu-width {
    width: 340px;
  }

  .dropdown-item-space {
    white-space: normal !important;
  }
</style>